import { apiFetch } from '../../apiFetch'

export const getAdminNpcPlacements = () =>
  apiFetch({ path: '/admin/npc_placements' })

export const getAdminDungeonNpcs = async (dungeonId) =>
  apiFetch({ path: `/admin/dungeons/${dungeonId}/npcs` })

export const createAdminDungeonNpc = async (dungeonId, data) =>
  apiFetch({ path: `/admin/dungeons/${dungeonId}/npcs`, method: 'POST', payload: data })

export const updateAdminDungeonNpc = async (dungeonId, placementId, data) =>
  apiFetch({ path: `/admin/dungeons/${dungeonId}/npcs/${placementId}`, method: 'PUT', payload: data })

export const deleteAdminDungeonNpc = async (dungeonId, placementId) =>
  apiFetch({ path: `/admin/dungeons/${dungeonId}/npcs/${placementId}`, method: 'DELETE' })
